import moment from 'moment';
import { Link } from 'react-router-dom';
import { Card, Checkbox } from 'antd';
import { FaUserMd, FaCalendarAlt, FaClock, FaInfoCircle } from 'react-icons/fa';
import img from '../../../images/avatar.jpg';
import TurnstileWidget from '../../UI/TurnstileWidget';
import './BookingCheckout.css';
import '../../Appointment/AppointmentFlow.css';

const CheckoutPage = ({ handleChange, selectValue, isCheck, setIsChecked, data, selectedDate, selectTime, onCaptchaToken }) => {
  const handleCheck = () => setIsChecked(!isCheck);
  const doctorImg = data?.img ?? img;

  const fullName = data
    ? `Dr. ${(data.firstName || '')} ${(data.lastName || '')}`.trim()
    : 'Doctor';

  return (
    <div className="appointment-step appointment-step--payment">
      <p className="appointment-step__title">Confirm Booking Request</p>
      <p className="appointment-step__subtitle">Review your requested appointment details and submit.</p>

      <div className="checkout-layout">
        <div>
          <Card className="checkout-form-card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', background: '#f0f7ff', borderRadius: '12px', marginBottom: '20px' }}>
              <FaInfoCircle style={{ color: '#1977cc', fontSize: '20px', flexShrink: 0 }} />
              <p style={{ margin: 0, color: '#4a6580', fontSize: '14px', lineHeight: '1.6' }}>
                Your selected time is a request — no payment is taken online. Our team will coordinate
                with the specialist, confirm the final appointment time with you, and arrange payment
                via email or WhatsApp. Specialists work to their own schedules, so the confirmed time
                may differ slightly from your request.
              </p>
            </div>

            {onCaptchaToken && <TurnstileWidget onToken={onCaptchaToken} />}

            <div className="terms-accept">
              <Checkbox id="terms_accept" checked={isCheck} onChange={handleCheck}>
                I confirm the details above are correct and I agree to the{' '}
                <a className="text-primary" href="#terms" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                  Terms &amp; Conditions
                </a>
              </Checkbox>
            </div>
          </Card>
        </div>

        <div>
          <Card className="order-summary-card">
            {data && (
              <div className="text-center mb-3">
                <Link to={`/doctors/profile/${data?.id}`} className="booking-doc-img d-block mb-2">
                  {doctorImg ? (
                    <img src={doctorImg} alt={fullName} style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover' }} />
                  ) : (
                    <div className="select-doctor-card__placeholder" style={{ width: 80, height: 80, borderRadius: '50%', margin: '0 auto' }}>
                      <FaUserMd style={{ fontSize: '2rem' }} />
                    </div>
                  )}
                </Link>
                <h5 className="mb-0" style={{ fontSize: '1rem', fontWeight: 600 }}>{fullName}</h5>
                <p className="form-text mb-0 small">{data?.designation}</p>
                {data?.specialization && <p className="form-text mb-0 small">{data.specialization}</p>}
              </div>
            )}
            <div className="summary-row">
              <span><FaCalendarAlt style={{ marginRight: 8 }} /> Preferred date</span>
              <span>{selectedDate ? moment(selectedDate).format('LL') : 'Any date'}</span>
            </div>
            <div className="summary-row">
              <span><FaClock style={{ marginRight: 8 }} /> Preferred time</span>
              <span style={{ textTransform: 'capitalize' }}>{selectTime || 'Anytime'}</span>
            </div>
            <div className="summary-row summary-total">
              <span>Payment</span>
              <span style={{ color: '#1977cc', fontWeight: 600 }}>Invoice will be sent</span>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
